export default __webpack_public_path__ + "static/media/Group 2032@2x.4bc0e0d0.png";